<div id="heading">
    <h1>Search Facility</h1>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">About Us</a></li>
            <li class="breadcrumb-item active" aria-current="page">Search Facility</li>
        </ol>
    </nav>
</div>

<div id="organ">
    <div class="container-fluid">
        <div class="card pl-3 pr-3 text-justify ml-lg-5">
            <h4 class="card-title text-center">Search Facility</h4>

            <div class="card-body">
                <p class="lead text-center">
                    Undertaking by the Principal, Guru Nanak Khalsa College, Yamuna Nagar
                </p>


                <!-- IMAGE ON TOP -->
                <div class="row text-center mb-4">
                    <div class="col-12">
                        <img src="/assets/img/about-us/search.jpg" style="height: 600px;" alt="search"
                            class="img-fluid rounded">
                    </div>
                </div>

                <!-- TEXT CONTENT -->
                
                <ol class="inner-lead">
                    <li>
                        <p class="lead">
                            Establishment and composition of the Internal Complaints Committee (ICC)
                            strictly as per the UGC (Prevention, Prohibition and Redressal of sexual
                            harassment of Women Employees and Students in HEIs) Regulations, 2016.
                            <br>
                            <a href="https://www.sxccal.edu/wp-content/uploads/2023/06/POSH-ACT-AND-UGC-REGULATIONS.pdf"
                                target="_blank">
                                https://www.sxccal.edu/wp-content/uploads/2023/06/POSH-ACT-AND-UGC-REGULATIONS.pdf
                            </a>
                        </p>
                    </li>

                    <li>
                        <p class="lead">
                            UGC (Redress of Grievances of Students) Regulations, 2023, and Composition
                            of SGRC as per these Regulations:
                            <br>
                            <a href="https://www.ugc.gov.in/pdfnews/4675881_Regulation.pdf" target="_blank">
                                https://www.ugc.gov.in/pdfnews/4675881_Regulation.pdf
                            </a>
                        </p>
                    </li>

                    <li>
                        <p class="lead">
                            Guidelines for Institutional Development Plans for Higher Education Institutions:
                            <br>
                            <a href="https://www.education.gov.in/en/guidelines-institutional-development-plans-higher-education-institutions"
                                target="_blank">
                                https://www.education.gov.in/en/guidelines-institutional-development-plans-higher-education-institutions
                            </a>
                        </p>
                    </li>

                    <li>
                        <p class="lead">
                            Guidelines "Accessibility Guidelines and Standards for Higher Education
                            Institutions and Universities"
                            <br>
                            <a href="https://www.ugc.gov.in/KeyInitiative?ID=MNJdt2jZ+aRpA/DRRKQwyg==" target="_blank">
                                https://www.ugc.gov.in/KeyInitiative?ID=MNJdt2jZ+aRpA/DRRKQwyg==
                            </a>
                        </p>
                    </li>

                    <li>
                        <p class="lead">
                            Guidelines for Establishment of Research & Development Cell in Higher
                            Education Institutions (HEIs):
                            <br>
                            <a href="https://www.ugc.gov.in/KeyInitiative?ID=Ox9NUJ/7LE8xivPCZ476jg==" target="_blank">
                                https://www.ugc.gov.in/KeyInitiative?ID=Ox9NUJ/7LE8xivPCZ476jg==
                            </a>
                        </p>
                    </li>

                    <li>
                        <p class="lead">
                            UGC Fee Refund Policy:
                            <br>
                            <a href="https://www.ugc.gov.in/pdfnews/1857727_Fee-Refund-Policy-2025-26.pdf"
                                target="_blank">
                                https://www.ugc.gov.in/pdfnews/1857727_Fee-Refund-Policy-2025-26.pdf
                            </a>
                        </p>
                    </li>

                    <li>
                        <p class="lead">
                            UGC Curbing the Menace of Ragging in Higher Educational Institutions
                            (Second Amendment) Regulations, 2013:
                            <br>
                            <a href="https://in.search.yahoo.com/search?fr=mcafee&type=E210IN826G0&p=UGC+Curbing+the+Menace+of+Ragging+in+Higher+Educational+Institutions+(Second+Amendment)+Regulations%2C+2013"
                                target="_blank">
                                https://in.search.yahoo.com/search?fr=mcafee&type=E210IN826G0&p=UGC+Curbing+the+Menace+of+Ragging+in+Higher+Educational+Institutions+(Second+Amendment)+Regulations%2C+2013
                            </a>
                        </p>
                    </li>

                    <li>
                        <p class="lead">
                            Guidelines to Provide Equitable Opportunity for the Socio-Economically
                            Disadvantaged Group (SEDGs) in the HEIs:
                            <br>
                            <a href="https://www.ugc.gov.in/pdfnews/2540260_SEDGs-Guidelines.pdf" target="_blank">
                                https://www.ugc.gov.in/pdfnews/2540260_SEDGs-Guidelines.pdf
                            </a>
                        </p>
                    </li>
                </ol>

            </div>
        </div>
    </div>
</div>